import styled, { css, keyframes } from 'styled-components';

export const StrikethroughPrice = styled.span.attrs({
  'data-testid' : 'strike-price',
})`
  text-decoration: line-through;
  opacity: 0.6;
  margin-left: 8px;
`;

// Width of the shimmer highlight band that animates across the skeleton.
// Single source of truth for both keyframe positions and background-size.
const SHIMMER_WIDTH_PX = 200;

const shimmer = keyframes`
  0% { background-position: -${SHIMMER_WIDTH_PX}px 0; }
  100% { background-position: calc(${SHIMMER_WIDTH_PX}px + 100%) 0; }
`;

/**
 * Animated skeleton surface (shimmer), with the animation disabled under
 * `prefers-reduced-motion: reduce` (WCAG 2.3.3). Shared by PriceSkeleton
 * and the ResaleSoldOutState placeholder.
 */
export const skeletonShimmer = css`
  background: linear-gradient(90deg, #eee 0px, #f5f5f5 40px, #eee 80px);
  background-size: ${SHIMMER_WIDTH_PX}px 100%;
  animation: ${shimmer} 1.2s infinite linear;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    background: #eee;
  }
`;

/**
 * Loading placeholder rendered while a FastPass offer is being resolved.
 *
 * Respects `prefers-reduced-motion: reduce` (WCAG 2.3.3) by halting the
 * shimmer animation for users with vestibular sensitivities.
 *
 * Shared between `ResaleSummary` (desktop) and `ResaleSummaryMobile` so any
 * visual tweak applies to both variants — desktop/mobile parity is enforced
 * by import, not by copy-paste.
 */
export const PriceSkeleton = styled.span.attrs({
  'data-testid' : 'price-skeleton',
})`
  display: inline-block;
  width: 80px;
  height: 20px;
  border-radius: 4px;
  ${skeletonShimmer}
  vertical-align: middle;
`;
